import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedBlog } from "../../features/relatedBlogs/relatedBlogSlice";
import Loading from "../utils/Loading";
import RelatedBlog from "./RelatedBlog";
export default function RelatedBlogs({ id, tags }) {
  const dispatch = useDispatch();
  const { isLoading, isError, relatedBlogs, error } = useSelector(
    (state) => state.relatedBlogs
  );

  useEffect(() => {
    dispatch(fetchRelatedBlog({ id, tags }));
  }, [dispatch, id, tags]);

  //Decide what to render
  let content;

  if (isLoading) {
    content = <Loading />;
  }

  if (!isLoading && isError) {
    content = <div className="text-lg text-gray-500">{error}</div>;
  }

  if (!isLoading && !isError && relatedBlogs?.length === 0) {
    content = <p className="text-lg text-gray-500">No Related Blogs Found</p>;
  }

  if (!isLoading && !isError && relatedBlogs?.length > 0) {
    content = content = relatedBlogs.map((blog) => (
      <RelatedBlog
        key={blog.id}
        blog={blog}
      />
    ));
  }
  return (
    <aside>
      <h4
        className="mb-4 text-xl font-medium"
        id="lws-relatedPosts"
      >
        Related Post
      </h4>
      <div className="space-y-4 related-post-container">{content}</div>
    </aside>
  );
}
